export default "__VITE_ASSET__c02dacbc__"